import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  root: {
    width: "calc(100% + 32px)",
    margin: "-8px -16px -8px",
    "& .BrainhubCarousel .BrainhubCarousel__trackContainer .BrainhubCarousel__track":
      {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 12,
        paddingRight: 12
      }
  },
  slide: {
    width: "100%",
    height: "100%"
  }
}));
